import type { NotificationReason } from 'zaptic-types'
import { createStringEnum } from '../../lib/typeHelpers.no-deps'
import { assert, type Equals } from 'tsafe'

export const notificationReasons = createStringEnum(
    'AssignedAnActionToYou',
    'AssignedYourActionToSomeoneElse',
    'AssignedAnActionYouCreatedToSomeoneElse',
    'ChangedStatusOfYourReport',
    'CommentedOnAPostYouFollow',
    'CommentedOnYourPost',
    'CompletedActionYouCreated',
    'CompletedAnActionYouCreatedForAssignee',
    'CompletedAnActionForYou',
    'MentionedYou',
    'RemovedActionAssignedToYou',
    'RemovedActionYouCreated',
    'UpdatedAnActionAssignedToYou',
    'UpdatedAnActionYouCreated',
    'EditedYourReport',
    'AssignedTaskWithTrainingToYou',
    'ReportReadyForReview'
)

/** Assert that the types match */
assert<Equals<NotificationReason, (typeof notificationReasons)[number]>>()
